import { render, staticRenderFns } from "./MedicineFormItem.vue?vue&type=template&id=3755fdeb&scoped=true&"
import script from "./MedicineFormItem.vue?vue&type=script&lang=ts&"
export * from "./MedicineFormItem.vue?vue&type=script&lang=ts&"
import style0 from "./MedicineFormItem.vue?vue&type=style&index=0&id=3755fdeb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3755fdeb",
  null
  
)

export default component.exports